import { Route, Routes } from 'react-router-dom';

import { List } from './List';

export default function NganHangThuHuongTemplate() {

  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  );
}
